import React from 'react';
import { Check, Mail, HelpCircle, ShieldCheck, Lock, Star, PlayCircle } from 'lucide-react';
const CTAButton = ({
  className = ''
}: {
  className?: string;
}) => <div data-id="element-1577">
    <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-ac" className={`block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-4 px-4 rounded-lg text-center transition-colors shadow-lg ${className}`} data-id="element-1578">
      <span className="block text-sm font-normal mb-1" data-id="element-1579">Ga naar stap #2</span>
      <span className="block text-xl" data-id="element-1580">Start de cursus nu</span>
    </a>
    <img src="https://cdn.magicpatterns.com/uploads/4vdV4HP3iomaCgiRo35kk3/ORAweI9onQltdmefOLBalrxDMg.png" alt="Betaalmethoden: Mastercard, CB, Apple Pay, iDEAL, SEPA, Visa, PayPal, American Express, Klarna, Bancontact" className="mx-auto mt-3 h-10 w-auto max-w-[280px] opacity-80" data-id="element-1581" />
  </div>;
const PricingCard = () => <div className="bg-white rounded-xl shadow-xl p-6 border-t-8 border-[#5ce0d2] text-center flex flex-col h-full" data-id="element-1582">
    <h3 className="text-[#5ce0d2] font-extrabold text-2xl mb-1 uppercase tracking-wide" data-id="element-1583">
      Nu nog beschikbaar
    </h3>
    <h2 className="text-4xl font-black text-[#1a2b4a] mb-6" data-id="element-1584">Start vandaag</h2>

    <div className="mb-6" data-id="element-1585">
      <img src="https://cdn.magicpatterns.com/uploads/sZnnt8dxKLASfHTcPAVy58/lc_devices_mockup.png" alt="Liefdevol Communiceren Cursus - training op laptop, tablet en telefoon" className="w-full h-auto object-contain" data-id="element-1586" />
    </div>

    <div className="text-[#e53e3e] font-black text-4xl mb-1" data-id="element-1587">Nu voor €127</div>
    <div className="text-[#e53e3e] font-bold text-lg mb-6" data-id="element-1588">(Bespaar €70)</div>

    <p className="text-sm text-gray-600 mb-6 leading-relaxed" data-id="element-1589">
      Start met de Liefdevol Communiceren Cursus voor €127 in plaats van{' '}
      <span className="line-through" data-id="element-1590">€197</span>. Per direct toegang. Start
      binnen de 3 minuten.
    </p>

    <p className="text-[#22c55e] font-bold text-sm mb-6" data-id="element-1591">
      Nu beschikbaar voor directe toegang
    </p>

    <CTAButton className="mb-4" data-id="element-1592" />

    <div className="text-xs text-gray-500 space-y-2 mt-auto pt-4" data-id="element-1593">
      <p className="flex items-center justify-center gap-1" data-id="element-1594">
        <Lock className="w-4 h-4" data-id="element-1595" /> 100% veilig afrekenen
      </p>
      <p className="flex items-center justify-center gap-1" data-id="element-1596">
        <ShieldCheck className="w-4 h-4" data-id="element-1597" /> Met onze 100% geld terug garantie
      </p>
    </div>
  </div>;
export function LiefdevolCommunicerenACPage() {
  return <div className="min-h-screen bg-[#faf5eb] font-sans text-gray-800 pb-24 md:pb-0" data-id="element-1598">
      {/* 1. HEADER */}
      <div className="bg-white py-3 px-4" data-id="element-1599">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-1600">
          <div className="flex-1 hidden md:block" data-id="element-1601"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-1602" />
          <div className="flex-1 flex justify-center md:justify-end" data-id="element-1603">
            <a href="mailto:amee@stresslessdogs.nl" className="flex items-center text-sm font-bold text-[#1a2b4a] hover:text-[#5ce0d2] transition-colors" data-id="element-1604">
              <Mail className="w-5 h-5 mr-2" data-id="element-1605" />
              Hulp nodig? Mail mij op amee@stresslessdogs.nl
            </a>
          </div>
        </div>
      </div>

      {/* 2. SUB BANNER */}
      <div className="bg-[#EDEDED] text-[#1a2b4a] text-center py-4 px-4 font-bold text-sm md:text-base tracking-wide" data-id="element-1606">
        Voor baasjes die eindelijk de verborgen taalbarrière met hun hond willen
        doorbreken (en een echte, diepe band willen opbouwen)
      </div>

      {/* 3. HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-16" data-id="element-1607">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-[#1a2b4a] text-center mb-6 leading-tight" data-id="element-1608">
          Jouw hond is niet 'koppig' of 'ongehoorzaam' - je spreekt zijn taal
          niet. Ontdek hoe je vloeiend de hondentaal leert spreken in 3 stappen.
        </h1>
        <p className="text-lg md:text-2xl text-center text-gray-700 mb-12 max-w-4xl mx-auto font-medium leading-relaxed" data-id="element-1609">
          Zodat jij je hond écht begrijpt, je probleemgedrag kan stoppen zonder
          straffen of corrigeren en jullie de meest liefdevolle band krijgen die
          je als baasje met je hond kan hebben.
        </p>

        <div className="grid md:grid-cols-12 gap-8 items-start" data-id="element-1610">
          <div className="md:col-span-8" data-id="element-1611">
            <div className="rounded-xl overflow-hidden shadow-2xl bg-black border-4 border-white" data-id="element-1612">
              <div style={{
              padding: '56.25% 0 0 0',
              position: 'relative'
            }} data-id="element-1613">
                <iframe src="https://player.vimeo.com/video/1099360202?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="Hero Video" data-id="element-1614"></iframe>
              </div>
            </div>
            <p className="text-center text-sm text-gray-500 mt-3 underline cursor-pointer" data-id="element-1615">
              Klik op afspelen om de video te starten
            </p>

            {/* Wat is de nieuwe Verlatingsangst Kernaanpak? - direct under video */}
            <div className="mt-8" data-id="element-1616">
              <h2 className="text-3xl font-bold text-[#5ce0d2] mb-4 text-center" data-id="element-1617">
                Wat is de Liefdevol Communiceren Methode?
              </h2>
              <div className="text-lg text-gray-700 leading-relaxed space-y-4" data-id="element-1618">
                <p data-id="element-1619">
                  De Liefdevol Communiceren Methode is een stap voor stap aanpak
                  die hondenbaasjes helpt om de verborgen taal van hun hond te
                  leren lezen, te begrijpen en zelf vloeiend terug te spreken.
                </p>
                <p data-id="element-1620">
                  We laten je precies zien hoe jouw hond de hele dag met je
                  communiceert via subtiele lichaamssignalen, en hoe jij op een
                  manier terugpraat die hij van nature begrijpt — zonder dwang,
                  straf of dominantie.
                </p>
                <p className="font-bold text-[#1a2b4a]" data-id="element-1621">
                  Zodat jullie relatie niet gebaseerd is op gehoorzaamheid, maar
                  op wederzijds begrip en vertrouwen. (Waardoor je hond naar je
                  gaat luisteren omdat die je begrijpt, je vertrouwt en je
                  respecteert).
                </p>
              </div>
            </div>
          </div>

          <div className="md:col-span-4" data-id="element-1622">
            <PricingCard data-id="element-1623" />
          </div>
        </div>
      </section>

      {/* 6. VOOR WIE WERKT DIT */}
      <section className="max-w-4xl mx-auto px-4 py-12" data-id="element-1624">
        {/* 6. VOOR WIE WERKT DIT */}
        <div className="bg-white rounded-xl shadow-md p-8 mb-12 border border-gray-100" data-id="element-1625">
          <h3 className="text-2xl font-bold text-[#1a2b4a] mb-6" data-id="element-1626">
            Voor wie werkt dit
          </h3>
          <p className="mb-6 text-gray-700" data-id="element-1627">
            Voor alle baasjes die worstelen met gedragsproblemen en het gevoel
            hebben dat ze hun hond niet echt begrijpen:
          </p>
          <ul className="space-y-4" data-id="element-1628">
            {['Het maakt niet uit als je nog nooit eerder iets hebt geleerd over hondentaal of lichaamssignalen.', 'De methode is eenvoudig en direct toepasbaar. Met slechts 30 minuten per dag zie je binnen een week al de eerste verbeteringen, en binnen twee tot vier weken ontstaat er een compleet nieuwe relatie.', 'Geschikt voor honden van alle leeftijden, rassen en formaten.', 'Werkt ook bij angstige honden, overprikkelde honden of honden met een rugzakje'].map((item, i) => <li key={i} className="flex items-start" data-id="element-1629">
                <Check className="w-6 h-6 text-[#22c55e] mr-3 flex-shrink-0 mt-0.5" data-id="element-1630" />
                <span className="text-gray-800 font-medium text-lg" data-id="element-1631">
                  {item}
                </span>
              </li>)}
          </ul>

          {/* Desire Stack */}
          <div className="mt-8 pt-8 border-t border-gray-100" data-id="element-1632">
            <h4 className="text-xl font-bold text-[#1a2b4a] mb-4" data-id="element-1633">
              Stel je voor dat je straks…
            </h4>
            <ul className="space-y-3" data-id="element-1634">
              {['Precies weet hoe je je hond op zijn gemak stelt als hij onrustig wordt - zonder te schreeuwen of te corrigeren.', 'Zijn stresssignalen herkent vóórdat het escaleert, zodat je hem kunt geruststellen op het moment dat hij het nodig heeft.', 'Ontspannen kunt wandelen zonder constant alert te zijn op andere honden of mensen.', "Zonder commando's communiceert met je hond, gewoon door je lichaamstaal - en hij begrijpt je meteen.", 'Visite kunt ontvangen zonder dat je hond door het lint gaat of dat jij je moet verontschuldigen.', 'Eindelijk die diepe, rustige band voelt waar je altijd van hebt gedroomd - elke dag opnieuw.'].map((item, i) => <li key={`desire-${i}`} className="flex items-start" data-id="element-1635">
                  <Star className="w-5 h-5 text-[#ffb800] mr-3 flex-shrink-0 mt-0.5" data-id="element-1636" />
                  <span className="text-gray-700 text-lg" data-id="element-1637">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        {/* 7. MET DE METHODE */}
        <h3 className="text-2xl font-bold text-[#1a2b4a] mb-4" data-id="element-1638">
          Met de Liefdevol Communiceren Methode…
        </h3>
        <div className="text-lg text-gray-700 leading-relaxed mb-12 space-y-4" data-id="element-1639">
          <p data-id="element-1640">
            ...leer je in drie stappen de taal van je hond te lezen én te
            spreken, zodat jullie eindelijk op één lijn zitten en
            gedragsproblemen vanzelf verminderen.
          </p>
          <p data-id="element-1641">
            Waardoor je hond zich begrepen voelt en jullie samenwerking soepeler
            gaat dan je ooit voor mogelijk hield.
          </p>
          <p className="font-bold text-[#1a2b4a]" data-id="element-1642">
            Geen frustratie meer dat je alles hebt geprobeerd maar niets werkt.
          </p>
        </div>

        <div className="mb-12 rounded-xl overflow-hidden shadow-lg" data-id="element-1643">
          <img src="https://cdn.magicpatterns.com/uploads/fGHv8ypZfDoYKf4ChjPLqb/IMG-20171008-WA0012.jpg" alt="Hond ontspannen op de bank terwijl baasje weggaat" className="w-full h-auto object-cover" data-id="element-1644" />
        </div>

        {/* 8. SIGNALEN */}
        <div className="bg-[#e6f7f5] rounded-xl p-8 mb-12" data-id="element-1645">
          <h3 className="text-2xl font-bold text-[#1a2b4a] mb-6" data-id="element-1646">
            Herken jij dit bij jouw hond?
          </h3>
          <ul className="space-y-4" data-id="element-1647">
            {['Springt tegen visite op, blaft de bezorger af, of wordt helemaal gek als er iemand aan de deur komt', 'Trekt als een bezetene aan de lijn of valt uit naar andere honden tijdens het wandelen', 'Pakt eten van tafel, luistert niet als je hem roept, of negeert je compleet in het park', 'Is constant druk in huis, kan niet tot rust komen op zijn plek, of volgt je overal naartoe', 'Reageert angstig op geluiden, nieuwe plekken of onbekende mensen - en jij weet niet hoe je hem gerust kunt stellen', 'Het gevoel dat je alles al hebt geprobeerd, maar dat jullie nog steeds langs elkaar heen leven', 'Hij vertrouwt je niet echt'].map((item, i) => <li key={i} className="flex items-start" data-id="element-1648">
                <Check className="w-6 h-6 text-[#5ce0d2] mr-3 flex-shrink-0 mt-0.5" data-id="element-1649" />
                <span className="text-gray-800 font-medium text-lg" data-id="element-1650">
                  {item}
                </span>
              </li>)}
          </ul>
          <p className="mt-6 text-lg font-bold text-[#1a2b4a]" data-id="element-1651">
            Dan is deze cursus voor jou.
          </p>
        </div>
      </section>

      {/* 9. FULL WIDTH PRICING CTA */}
      <section className="bg-white py-16 border-y border-gray-200" data-id="element-1652">
        <div className="max-w-4xl mx-auto px-4" data-id="element-1653">
          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-1654">
            <div data-id="element-1655">
              <h2 className="text-3xl font-black text-[#1a2b4a] mb-4" data-id="element-1656">
                Start vandaag
              </h2>
              <div className="text-[#e53e3e] font-black text-4xl mb-1" data-id="element-1657">
                Nu voor €127
              </div>
              <div className="text-[#e53e3e] font-bold text-lg mb-4" data-id="element-1658">
                (Bespaar €70)
              </div>
              <p className="text-gray-600 mb-6" data-id="element-1659">
                Start met de Liefdevol Communiceren Cursus voor €127 in plaats
                van <span className="line-through" data-id="element-1660">€197</span>. Per direct
                toegang. Start binnen de 3 minuten.
              </p>
            </div>
            <div data-id="element-1661">
              <CTAButton data-id="element-1662" />
              <div className="text-xs text-gray-500 space-y-2 mt-4 text-center" data-id="element-1663">
                <p className="flex items-center justify-center gap-1" data-id="element-1664">
                  <Lock className="w-4 h-4" data-id="element-1665" /> 100% veilig afrekenen
                </p>
                <p className="flex items-center justify-center gap-1" data-id="element-1666">
                  <ShieldCheck className="w-4 h-4" data-id="element-1667" /> Met onze 100% geld terug
                  garantie
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 10. DETAILED EXPLANATION + SIDEBAR */}
      <section className="max-w-7xl mx-auto px-4 py-16" data-id="element-1668">
        <div className="grid lg:grid-cols-12 gap-8" data-id="element-1669">
          {/* Left column - main content */}
          <div className="lg:col-span-8" data-id="element-1670">
            <h2 className="text-3xl font-bold text-[#5ce0d2] mb-6" data-id="element-1671">
              Wat is de Liefdevol Communiceren Methode?
            </h2>
            <div className="text-lg text-gray-700 leading-relaxed mb-12 space-y-4" data-id="element-1672">
              <p data-id="element-1673">
                Een commando heeft pas zin als je eerst dezelfde taal spreekt
                als je hond.
              </p>
              <p data-id="element-1674">
                Doe je dat niet, dan blijft er een onzichtbare muur tussen
                jullie staan. Je hond snapt niet wat je tegen hem zegt, en jij
                begrijpt niet waarom. Want jullie spreken letterlijk een andere
                taal.
              </p>
              <p data-id="element-1675">
                Jouw hond communiceert de hele dag subtiele signalen. Dat je die
                soms mist, is niet jouw schuld. De ouderwetse hondenindustrie
                heeft ons decennialang verteld dat honden gewoon moeten
                'luisteren', in plaats van ons te leren hoe we hun taal kunnen
                lezen.
              </p>
              <p data-id="element-1676">
                Oude trainingsmethodes laten je geloven dat je hond 'koppig' of
                'dominant' is als die niet luistert, terwijl jullie in
                werkelijkheid elkaar niet begrijpen. Zodra je weet hoe je op een
                manier communiceert die hij vanuit zijn natuur snapt, valt die
                frustratie direct weg.
              </p>
              <p className="font-medium" data-id="element-1677">
                Daarom moet je eerst de taalbarrière doorbreken. Dit is hoe het
                werkt.
              </p>
            </div>

            {/* 11. 3 STEPS */}
            <div className="mb-8 rounded-xl overflow-hidden" data-id="element-1678">
              <img src="https://cdn.magicpatterns.com/uploads/43tvVR32w9VpvEgS87mE9U/liefdevol_vergelijking_v4.png" alt="Oude Aanpak vs De Liefdevol Communiceren Methode" className="w-1/2 h-auto object-contain rounded-lg mx-auto" data-id="element-1679" />
            </div>
            <h2 className="text-3xl font-bold text-[#1a2b4a] mb-8 text-center" data-id="element-1680">
              De taalbarrière doorbreken in drie stappen
            </h2>
            <div className="space-y-8 mb-16" data-id="element-1681">
              {[{
              title: 'Stap 1: Hondentaal',
              text: 'De eerste stap is de taal van je hond leren. Je hond communiceert de hele dag via subtiele lichaamssignalen. In stap 1 leer je deze signalen herkennen en begrijpen, zodat je eindelijk weet wat je hond je probeert te vertellen.'
            }, {
              title: 'Stap 2: Terugpraten',
              text: 'De tweede stap is zelf in die taal terugpraten. Je leert hoe je met handgebaren en lichaamstaal signalen communiceert op een manier die je hond van nature begrijpt. Geen geschreeuw, geen straffen - gewoon duidelijke, liefdevolle communicatie die hij meteen oppikt.'
            }, {
              title: 'Stap 3: Samenwerken',
              text: 'En dan, als jullie dezelfde taal spreken… Ga je als derde stap écht samenwerken. Niet meer commanderen en gehoorzamen, maar een gelijkwaardige samenwerking gebaseerd op begrip en vertrouwen. Gedragsproblemen lossen zichzelf op, want de oorzaak - miscommunicatie - is verdwenen.'
            }].map((step, i) => <div key={i} className="flex gap-6 items-start" data-id="element-1682">
                  <div className="w-12 h-12 rounded-full bg-[#5ce0d2] text-white flex items-center justify-center font-bold text-2xl flex-shrink-0 mt-1" data-id="element-1683">
                    {i + 1}
                  </div>
                  <div data-id="element-1684">
                    <p className="text-lg text-gray-700 leading-relaxed" data-id="element-1685">
                      {step.text}
                    </p>
                  </div>
                </div>)}
            </div>
            <p className="text-lg text-gray-700 leading-relaxed mb-4 font-medium" data-id="element-1686">
              Op deze manier kan zelfs een hond die al jaren uitvalt, blaft of
              trekt leren om rustig en ontspannen te zijn — omdat hij zich
              eindelijk begrepen voelt en jij eindelijk begrijpt wat hij nodig
              heeft.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-8 font-medium" data-id="element-1687">
              Zonder frustratie, zonder straffen, zonder dominantie.
            </p>

            {/* 13. ZO PAS JE HET TOE */}
            <h2 className="text-3xl font-bold text-[#1a2b4a] mb-6" data-id="element-1688">
              Zo pas je de Liefdevol Communiceren Methode vandaag nog toe
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-1689">
              De Liefdevol Communiceren Methode is uniek in Nederland.
              Hondenscholen werken nog niet op deze manier. Maar wij vinden dat
              ieder hondenbaasje dat worstelt met de gedragsproblemen van zijn
              hond, of die zijn hond simpelweg beter wilt begrijpen, de kans zou
              moeten krijgen om hiermee aan de slag te gaan.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-12" data-id="element-1690">
              Daarom hebben we een videotraining gemaakt voor je. In deze
              training doorlopen we de drie essentiële stappen in deze aanpak.
              Dit doen we met een rustige uitleg, praktijkvoorbeelden en
              printbaar lesmateriaal.
            </p>

            <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-1691">
              {[{
              title: 'Stap 1',
              text: 'Na stap 1 begrijp je de subtiele lichaamssignalen van je hond en hoe je deze leest, zodat je zeker weet wat hij je probeert te vertellen.'
            }, {
              title: 'Stap 2',
              text: 'Na stap 2 snap je hoe je met handgebaren en je lichaam in hondentaal terugpraat, zodat je hond jou begrijpt en klaar is voor stap 3.'
            }, {
              title: 'Stap 3',
              text: 'En na stap 3 snap je hoe jullie als een team kunnen samenwerken, zodat gedragsproblemen vanzelf verdwijnen.'
            }].map((les, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-md border-t-4 border-[#5ce0d2]" data-id="element-1692">
                  <h4 className="font-bold text-xl text-[#1a2b4a] mb-3" data-id="element-1693">
                    {les.title}
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-1694">
                    {les.text}
                  </p>
                </div>)}
            </div>
            <p className="text-center font-bold text-gray-500 mb-16" data-id="element-1695">
              Zet vandaag nog de eerste stap.
            </p>
          </div>

          {/* Right column - sticky sidebar */}
          <div className="hidden lg:block lg:col-span-4" data-id="element-1696">
            <div className="sticky top-8" data-id="element-1697">
              <div className="bg-white rounded-xl overflow-hidden shadow-xl border border-gray-200" data-id="element-1698">
                {/* BIJ JE BESTELLING */}
                <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-black text-sm uppercase tracking-widest" data-id="element-1699">
                  BIJ JE BESTELLING
                </div>

                <div className="p-5" data-id="element-1700">
                  {/* Product */}
                  <div className="flex gap-4 items-start mb-6" data-id="element-1701">
                    <img src="https://cdn.magicpatterns.com/uploads/4wUNXnqn4DFV4J3eFkdeE5/lc_book_mockup.png" alt="Liefdevol Communiceren - Cursus" className="w-20 h-20 object-cover rounded-lg flex-shrink-0" data-id="element-1702" />
                    <div data-id="element-1703">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-1704">
                        LIEFDEVOL COMMUNICEREN - CURSUS
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-1705">
                        Gedetailleerde uitleg van hoe je de verborgen
                        taalbarrière in 3 stappen doorbreekt en een diepe band
                        opbouwt
                      </p>
                    </div>
                  </div>

                  {/* 5 FREE FAST ACTION BONUSES */}
                  <div className="bg-[#1a2b4a] text-white text-center py-2 px-3 font-black text-xs uppercase tracking-widest rounded-md mb-5" data-id="element-1706">
                    3 x GRATIS BONUS
                  </div>

                  {/* Bonus 1 */}
                  <div className="flex gap-3 items-start mb-5" data-id="element-1707">
                    <img src="https://cdn.magicpatterns.com/uploads/kK8kyQqoZHm31F5VUdBjhD/2.png" alt="30 Dagen Community Toegang" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-1708" />
                    <div data-id="element-1709">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-1710">
                        30 DAGEN COMMUNITY TOEGANG
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-1711">
                        Stuur vragen, foto's en videos naar onze experts, neem
                        deel aan meerdere wekelijkse online coachingsessies en
                        kom in contact met andere hondenbaasjes.
                      </p>
                    </div>
                  </div>

                  {/* Bonus 2 */}
                  <div className="flex gap-3 items-start mb-5" data-id="element-1712">
                    <img src="https://cdn.magicpatterns.com/uploads/jpptdiaLg8Jy3uMEh1EZiz/3.png" alt="Printbare Stappenplannen" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-1713" />
                    <div data-id="element-1714">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-1715">
                        Printbare Stappenplannen
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-1716">
                        Handige, printbare overzichten van alle lichaamssignalen
                        en kalmerende signalen om er altijd bij te kunnen
                        pakken.
                      </p>
                    </div>
                  </div>

                  {/* Bonus 3 */}
                  <div className="flex gap-3 items-start mb-6" data-id="element-1717">
                    <img src="https://cdn.magicpatterns.com/uploads/bbcA4WNP4wTigQiHJcajRX/4.png" alt="Levenslange Toegang" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-1718" />
                    <div data-id="element-1719">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-1720">
                        Levenslange Toegang
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-1721">
                        Je krijgt levenslange toegang tot al het lesmateriaal,
                        inclusief alle toekomstige updates van de cursus.
                      </p>
                    </div>
                  </div>

                  {/* RESULTATEN */}
                  <div className="bg-[#1a2b4a] text-white text-center py-2 px-3 font-black text-xs uppercase tracking-widest rounded-md mb-4" data-id="element-1722">
                    RESULTATEN VAN DE METHODE
                  </div>

                  {/* Vimeo video */}
                  <div className="rounded-lg overflow-hidden" data-id="element-1723">
                    <div style={{
                    padding: '112.5% 0 0 0',
                    position: 'relative'
                  }} data-id="element-1724">
                      <iframe src="https://player.vimeo.com/video/1084988962?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%'
                    }} title="Resultaten video" data-id="element-1725"></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 16. LETTER SECTION */}
      <section className="bg-white py-16" data-id="element-1726">
        <div className="max-w-6xl mx-auto px-4" data-id="element-1727">
          {/* Section headline */}
          <h2 className="text-3xl md:text-4xl font-black text-[#1a2b4a] text-center mb-4" data-id="element-1728">
            RESULTATEN VAN DE METHODE
          </h2>
          <p className="text-center text-lg text-gray-700 max-w-3xl mx-auto mb-8" data-id="element-1729">
            Dit is hoe ik hondenbaasjes help om de taalbarrière te doorbreken
            door eerst de hondentaal te leren, dit maakt de verdere samenwerking
            veel en veel makkelijker
          </p>

          <p className="text-xl font-bold text-[#5ce0d2] mb-12 text-center leading-relaxed max-w-3xl mx-auto" data-id="element-1730">
            Deze aanpak is nieuw, compleet anders, en verschilt van de eerdere
            aanpakken die je tot nu toe kent - lees mijn verhaal hieronder over
            het ontstaan van de Liefdevol Communiceren Methode
          </p>

          <div className="grid lg:grid-cols-12 gap-8" data-id="element-1731">
            {/* Left column - letter content */}
            <div className="lg:col-span-8" data-id="element-1732">
              <div className="bg-[#faf5eb] rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100" data-id="element-1733">
                <div className="prose prose-lg max-w-none text-gray-800" data-id="element-1734">
                  <p className="font-bold" data-id="element-1735">Beste hondenbaasje,</p>
                  <p data-id="element-1736">
                    <strong data-id="element-1737">Van:</strong> Amee de Bruijn
                  </p>
                  <p data-id="element-1738">
                    <strong data-id="element-1739">Re:</strong> De enige manier om gedragsproblemen
                    écht op te lossen, is door de taal van je hond te spreken
                    (en niet door te commanderen).
                  </p>
                  <p data-id="element-1740">
                    Misschien verbaast het je dat er een andere manier is dan
                    eindeloos corrigeren waarmee je gedragsproblemen sneller
                    kunt oplossen, met een minimale kans op terugval.
                  </p>
                  <p data-id="element-1741">En dat is niet gek.</p>
                  <p data-id="element-1742">
                    Want bijna alles wat je online vindt, draait om
                    symptoombestrijding: commando's, correcties, je hond
                    domineren, of afleiden met snoepjes.
                  </p>
                  <p data-id="element-1743">
                    Geen van deze methodes focust zich op het échte,
                    onderliggende probleem.
                  </p>
                  <p data-id="element-1744">
                    Waarom zou mijn verhaal dan wel waar zijn? Je kunt immers
                    niet alles geloven wat je op het internet leest.
                  </p>
                  <p className="font-bold text-xl text-[#1a2b4a] mt-8" data-id="element-1745">
                    Dus laat het me je bewijzen.
                  </p>
                  <div className="bg-white p-6 rounded-lg my-8 text-sm italic text-gray-600 border-l-4 border-gray-300" data-id="element-1746">
                    <strong data-id="element-1747">Maar lees eerst deze disclaimer:</strong> Ik heb het
                    voordeel van jarenlange ervaring en het doorbreken van oude
                    methodes. De gemiddelde persoon die een "zo-doe-je-dat"
                    methode volgt, behaalt weinig tot geen resultaten. Jouw
                    resultaten zijn afhankelijk van vele factoren, waaronder
                    vooral je bereidheid om te doen wat er in de methode staat.
                    Deze verandering vraagt erom dat je anders gaat kijken naar
                    je hond. Op een lievere, empatischere manier waarin je hond
                    geen robot is die zomaar bevelen op zou moeten volgen. Maar
                    meer een volwaardig gezinslid van een gezin waar jij aan het
                    hoofd staat. Als je er niet toe bereid bent zo naar je hond
                    te kijken, dan is deze methode misschien niet voor jou. Met
                    dat gezegd, laat me je laten zien hoe het anders kan.
                  </div>

                  <p className="font-bold text-2xl text-[#1a2b4a] mt-12 mb-6" data-id="element-1748">
                    Ik werk met een compleet andere methode die ik nu met jou ga
                    delen.
                  </p>
                  <p data-id="element-1749">
                    Dit is dezelfde Liefdevol Communiceren Methode die duizenden
                    hondeneigenaren nu gebruiken om onbegrip, irritaties en
                    problemen met hun hond écht op te lossen.
                  </p>
                  <p data-id="element-1750">
                    Hierdoor krijgen zij een ontspannen hond terug, sneller dan
                    ze ooit voor mogelijk hielden.
                  </p>
                  <p data-id="element-1751">
                    En het mooiste van alles? Ze bouwen een diepere, betere band
                    op met hun hond, gebaseerd op begrip in plaats van
                    frustratie.
                  </p>
                  <p className="font-bold" data-id="element-1752">
                    Dit is niet zomaar een stappenplan;
                  </p>
                  <p data-id="element-1753">
                    Het is een fundamenteel andere manier van samenleven met je
                    hond. We focussen ons niet op:
                  </p>
                  <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-1754">
                    <li data-id="element-1755">
                      Eindeloze gehoorzaamheidstrainingen die nergens toe
                      leiden.
                    </li>
                    <li data-id="element-1756">
                      Je hond straffen of corrigeren als hij iets 'fout' doet.
                    </li>
                    <li data-id="element-1757">Trucjes om je hond af te leiden met voer.</li>
                    <li data-id="element-1758">
                      Standaard protocollen die geen rekening houden met jouw
                      unieke hond.
                    </li>
                  </ul>
                  <p className="font-bold text-xl text-[#5ce0d2] p-6 bg-[#e6f7f5] rounded-lg my-8" data-id="element-1759">
                    In plaats daarvan doen we iets wat bijna niemand doet: we
                    beginnen met het leren van de taal van de hond zodat jullie
                    elkaar echt gaan begrijpen.
                  </p>
                  <p data-id="element-1760">
                    Dit is een compleet andere aanpak, en het heeft de kracht om
                    alles voor jou en je hond te veranderen. Ik weet dat dit
                    waar is, want het heeft alles voor mij veranderd.
                  </p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-1761">
                    Hoe ik dit ontdekte: De "Muur van Onbegrip" bij mijn klanten
                  </h3>
                  <p data-id="element-1762">
                    Als gedragsdeskundige zag ik dit patroon steeds terugkomen
                    bij mijn klanten. Ik noem het de "Muur van Onbegrip":
                  </p>
                  <div className="bg-white border border-gray-200 rounded-lg p-6 my-6 space-y-3 shadow-sm" data-id="element-1763">
                    <p data-id="element-1764">
                      <strong data-id="element-1765">Stap 1:</strong> Ze volgden online adviezen en
                      begonnen met strenge commando's en correcties.
                    </p>
                    <p data-id="element-1766">
                      <strong data-id="element-1767">Stap 2:</strong> De hond luisterde niet, dus ze
                      proberen strenger te zijn. Meer correcties.
                    </p>
                    <p data-id="element-1768">
                      <strong data-id="element-1769">Stap 3:</strong> Na een week leek de hond even te
                      luisteren uit angst. Een klein succes!
                    </p>
                    <p data-id="element-1770">
                      <strong data-id="element-1771">Stap 4:</strong> Maar het streng zijn voelt niet
                      fijn voor het baasje en is niet altijd consistent. Wat
                      weer verwarrend is voor de hond.
                    </p>
                    <p data-id="element-1772">
                      <strong data-id="element-1773">Stap 5:</strong> De hond onderdrukt deels zijn
                      reacties en de hele situatie levert hem stress op.
                    </p>
                    <p data-id="element-1774">
                      <strong data-id="element-1775">Stap 6:</strong> Stress bij de hond bouwt op
                      waardoor hij reactief wordt. Hij reageert ineens heftig op
                      straat, wordt angstig of gaat ander "probleemgedrag"
                      vertonen.
                    </p>
                    <p data-id="element-1776">
                      <strong data-id="element-1777">Stap 7:</strong> Met dit nieuwe gedrag beginnen ze
                      weer bij stap 1 (en voelen zich een slechte baas).
                    </p>
                  </div>
                  <p data-id="element-1778">
                    Ik zag hoe deze cirkel mijn klanten jarenlang gevangen
                    hield. Ze voelden zich machteloos en schuldig.
                  </p>
                  <p data-id="element-1779">
                    Ik voelde me gefrustreerd omdat ik zag dat ik hen niet echt
                    hielp. Ik was aan het symptoombestrijden, niet aan het
                    oplossen en het voelde slecht.
                  </p>
                  <p data-id="element-1780">
                    Ik stond op het punt om te geloven dat sommige honden gewoon
                    onhandelbaar waren en het vak als hondengedragsdeskundige
                    niks voor mij was.
                  </p>
                  <p data-id="element-1781">
                    Maar voordat ik opgaf, kwam ik in aanraking met een nieuwe
                    methode. En deze methode veranderde alles voor mij.
                  </p>

                  <div className="my-12 flex flex-col md:flex-row gap-8 items-center" data-id="element-1782">
                    <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee de Bruijn" className="w-48 h-48 rounded-full object-cover shadow-xl border-4 border-white" data-id="element-1783" />
                    <div data-id="element-1784">
                      <h3 className="text-2xl font-bold text-[#1a2b4a] mb-4" data-id="element-1785">
                        Mijn naam is Amee, en ik ken de frustratie als baasje.
                      </h3>
                      <div className="space-y-4" data-id="element-1786">
                        <p className="text-sm text-[#5ce0d2] font-bold uppercase tracking-wide" data-id="element-1787">
                          Gediplomeerd Hondengedragsconsultant & Natural Dog
                          Trainer (niveau 5, Calming Signs, 2017)
                        </p>
                        <p data-id="element-1788">
                          Als gedragsdeskundige zag ik steeds dezelfde pijn.
                          Honden die ondanks alle liefde die ze van hun baasje
                          krijgen nog steeds problemen hebben.
                        </p>
                        <p data-id="element-1789">
                          Eigenaren die alles voor hun hond over hebben, maar
                          waarvan de hond nog steeds niet altijd lekker in zijn
                          vel zit.
                        </p>
                        <p data-id="element-1790">
                          Geen ontspannen wandeling, altijd die knoop in je maag
                          als je een andere hond tegenkomt, reactieve hond die
                          reageert op alles buiten het huis, heftige reactie op
                          visite, en nog meer...
                        </p>
                        <p data-id="element-1791">
                          Na jarenlange ervaring met honderden honden en hun
                          baasjes, en een specialisatie in natuurlijk
                          hondengedrag en hondenlichaamstaal, ontwikkelde ik een
                          methode die niet draait om gehoorzaamheid, maar om
                          wederzijds begrip.
                        </p>
                      </div>
                    </div>
                  </div>

                  <p data-id="element-1792">
                    Keer op keer zag ik dat de standaard aanpak niet echt hielp.
                  </p>
                  <p data-id="element-1793">
                    Het keerpunt kwam bij een klant met een hond die meerdere
                    problemen had. We kregen het gedrag niet opgelost met de
                    standaard aanpak die ik toen ook nog toepaste.
                  </p>
                  <p data-id="element-1794">
                    Pas toen we alles loslieten, volledig stopten met
                    conditioneren en begonnen met het echt kijken naar zijn
                    signalen en wat hij nodig had - gebeurde er iets magisch.
                    Het probleemgedrag verdween daarna als sneeuw voor de zon.
                  </p>
                  <p data-id="element-1795">
                    Het was een Eureka-moment. Ineens viel alles op zijn plek.
                  </p>
                  <p className="font-bold text-xl text-[#1a2b4a] my-6" data-id="element-1796">
                    Ongehoorzaamheid was niet het probleem; het was een
                    symptoom.
                  </p>
                  <p data-id="element-1797">En die kijk maakt het verschil in alles dat ik doe.</p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-1798">
                    De #1 Fout die iedereen maakt: focussen op het symptoom
                  </h3>
                  <p data-id="element-1799">
                    De markt voor hondentraining is verdeeld in twee kampen. Je
                    hebt de "africhters" en je hebt de "liefdevolle
                    hondenouders". Wij van Stressless Dogs zijn dat laatste. Wij
                    geloven dat je als hondenbaasje eigenlijk geen echte "baas"
                    bent over je hond, maar meer een liefdevolle ouder.
                  </p>
                  <p data-id="element-1800">
                    Maar jarenlang was ik ook een africhter. Ik probeerde mijn
                    klanten te helpen door het blaffen, piepen en slopen af te
                    leren...
                  </p>
                  <p data-id="element-1801">
                    Alleen het probleem is niet het gedrag zelf. Het probleem is
                    waar het gedrag vandaan komt.
                  </p>
                  <p className="font-bold text-red-600" data-id="element-1802">
                    Het gevaarlijkste advies dat je kunt krijgen, is "strenger
                    en consistent zijn".
                  </p>
                  <p data-id="element-1803">
                    Waarom? Omdat honden wel willen samenwerken, maar vaak niet
                    snappen wat van hen verwacht wordt omdat het baasje
                    verkeerde signalen met zijn lichaam afgeeft.
                  </p>
                  <p data-id="element-1804">Door deze miscommunicatie krijgt de hond stress.</p>
                  <p data-id="element-1805">
                    En deze stress bouwt op en zorgt voor meer probleemgedrag.
                  </p>
                  <p data-id="element-1806">
                    Opgebouwde stress zorgt ervoor dat je hond reactief wordt,
                    sneller blaft naar voorbijgangers, aan de lijn gaat trekken,
                    uitvalt, en meer.
                  </p>
                  <p className="font-bold" data-id="element-1807">
                    Daarom is de oplossing anders dan je denkt.
                  </p>
                  <p className="font-bold" data-id="element-1808">
                    Zodra je de lichaamssignalen van je hond goed begrijpt zie
                    je wat hij denkt, wilt en waar hij stress van krijgt. En als
                    je terug communiceert op een manier die hij van nature
                    begrijpt. Dan raakt je hond veel meer op zijn gemak en zal
                    je zien dat hij naar je luistert.
                  </p>

                  <h3 className="text-2xl font-black text-[#1a2b4a] mt-12 mb-8" data-id="element-1809">
                    Wat je leert in deze training:
                  </h3>
                  <div className="space-y-6 not-prose" data-id="element-1810">
                    {[{
                    title: 'Stap 1: Hondentaal',
                    text: 'Leer de subtiele lichaamssignalen van je hond en hoe je ontdekt wat hij je precies probeert te vertellen.'
                  }, {
                    title: 'Stap 2: Terugpraten',
                    text: 'Krijg de tools om in zijn eigen taal terug te communiceren en een sterke, veerkrachtige vertrouwensband te leggen.'
                  }, {
                    title: 'Stap 3: Samenwerken',
                    text: 'Leer hoe je stressvrij en effectief kunt samenwerken, op een manier die past bij jouw hond, zodat je snel en blijvend resultaat boekt.'
                  }].map((les, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 flex gap-4 items-start" data-id="element-1811">
                        <PlayCircle className="w-8 h-8 text-[#5ce0d2] flex-shrink-0 mt-1" data-id="element-1812" />
                        <div data-id="element-1813">
                          <h4 className="font-bold text-xl text-[#1a2b4a] mb-2" data-id="element-1814">
                            {les.title}
                          </h4>
                          <p className="text-gray-700 m-0" data-id="element-1815">{les.text}</p>
                        </div>
                      </div>)}
                  </div>
                  <p className="text-gray-600 mt-8 italic" data-id="element-1816">
                    Daarnaast krijg je toegang tot casestudies en interviews met
                    klanten, zodat je precies ziet hoe deze aanpak in de
                    praktijk werkt.
                  </p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-1817">
                    Voor wie is deze methode (niet)?
                  </h3>
                  <p data-id="element-1818">
                    Deze methode is <strong data-id="element-1819">niet</strong> voor mensen die hun
                    hond zien als een robot die moet gehoorzamen. Het is niet
                    voor mensen die een snelle, magische oplossing zoeken zonder
                    bereid te zijn hun hond echt te begrijpen.
                  </p>
                  <p data-id="element-1820">
                    Deze methode is <strong data-id="element-1821">voor jou</strong> als je je hond
                    ziet als een volwaardig gezinslid. Als je gelooft dat hij
                    emoties en gevoelens heeft die gerespecteerd moeten worden.
                    En als je bereid bent om het anders te doen, op een manier
                    die op de lange termijn beter is voor zowel jou als je hond.
                  </p>
                  <p className="text-xl font-bold text-[#5ce0d2] mt-8 mb-12" data-id="element-1822">
                    Als je klaar bent om de cirkel van stress te doorbreken en
                    een diepere band met je hond te krijgen, dan is dit het
                    moment.
                  </p>

                  <div className="rounded-xl overflow-hidden shadow-lg mt-8" data-id="element-1823">
                    <img src="https://cdn.magicpatterns.com/uploads/7QbopuV5o2pEQqFw8GzzYw/Ontwerp_zonder_titel_(66).png" alt="Amee met hond buiten" className="w-full h-auto object-cover" data-id="element-1824" />
                  </div>
                </div>
              </div>
            </div>

            {/* Right column - sticky sidebar */}
            <div className="lg:col-span-4" data-id="element-1825">
              <div className="lg:sticky lg:top-8 space-y-6" data-id="element-1826">
                {/* Product image */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-1827">
                  <img src="https://cdn.magicpatterns.com/uploads/7kNRQ43TgkEzcEQikb1C2w/lc_devices_mockup.png" alt="Liefdevol Communiceren Cursus Training op verschillende apparaten" className="w-full h-auto object-contain" data-id="element-1828" />
                </div>

                {/* Wat je krijgt */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-1829">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-1830">
                    Dit is wat je krijgt met de training
                  </div>
                  <div className="p-5 space-y-5" data-id="element-1831">
                    <div className="flex items-start gap-3" data-id="element-1832">
                      <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-1833" />
                      <span className="text-sm font-bold text-gray-800" data-id="element-1834">
                        Drie stappen kernaanpak om jouw hond te leren alleen
                        thuis te blijven
                      </span>
                    </div>

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-1835">
                      Dit leer je in Stap 1
                    </p>
                    {['Hoezo commanderen geen nut heeft als je niet eerst dezelfde taal spreekt', 'Welke subtiele lichaamssignalen honden gebruiken en wat ze precies betekenen', 'Hoe je de signalen van jouw hond leest zodat je weet wat hij nodig heeft'].map((item, i) => <div key={`l1-${i}`} className="flex items-start gap-3" data-id="element-1836">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-1837" />
                        <span className="text-sm text-gray-700" data-id="element-1838">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-1839">
                      Dit leer je in Stap 2
                    </p>
                    {['Hoe je kalmerende signalen en handgebaren gebruikt om terug te praten', 'Wat je wel, en wat je juist niet moet doen met je lichaamstaal om misverstanden te voorkomen', 'Voorbeeld casus van hond Lemmy en hoe hij van extreem uitvallen naar ontspannen wandelen ging met deze methode', 'Voorbeeld casus van honden Mork & Dash en hoe zij hun frustratie in korte tijd overwonnen met deze methode'].map((item, i) => <div key={`l2-${i}`} className="flex items-start gap-3" data-id="element-1840">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-1841" />
                        <span className="text-sm text-gray-700" data-id="element-1842">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-1843">
                      Dit leer je in Stap 3
                    </p>
                    {['Effectief samenwerken zodat je op de juiste manier een diepe band opbouwt', 'Drie voorbeeld situaties waarin je de methode in de praktijk brengt'].map((item, i) => <div key={`l3-${i}`} className="flex items-start gap-3" data-id="element-1844">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-1845" />
                        <span className="text-sm text-gray-700" data-id="element-1846">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-1847">
                      Dit leer je in de bonus lessen
                    </p>
                    {['Masterclass hondengeschiedenis. Ontwikkeling van het diersoort en de ontwikkeling van wetenschappelijke onderzoeken en conclusies over hondengedrag.', 'Stress signalen herkennen zodat je weet of je hond hoog of laag in zijn stress zit', '3 Kalmerende activiteiten waarmee je jouw hond kan helpen ontspannen als zijn stress level te hoog is'].map((item, i) => <div key={`bonus-${i}`} className="flex items-start gap-3" data-id="element-1848">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-1849" />
                        <span className="text-sm text-gray-700" data-id="element-1850">{item}</span>
                      </div>)}
                  </div>
                </div>

                {/* First pricing CTA */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-1851">
                  <div className="bg-[#5ce0d2] text-[#1a2b4a] text-center py-3 px-4 font-bold text-sm" data-id="element-1852">
                    Start met de Liefdevol Communiceren Methode
                  </div>
                  <div className="p-5 text-center" data-id="element-1853">
                    <img src="https://cdn.magicpatterns.com/uploads/oEL2JDeiE1fJbhau44wGFR/lc_devices_mockup.png" alt="Liefdevol Communiceren Cursus Training" className="w-full h-auto object-contain mb-4 rounded-lg" data-id="element-1854" />
                    <div className="text-[#e53e3e] font-black text-3xl mb-1" data-id="element-1855">
                      Slechts €127
                    </div>
                    <div className="text-[#e53e3e] font-bold text-sm mb-3" data-id="element-1856">
                      (Bespaar €70)
                    </div>
                    <p className="text-gray-600 text-sm mb-2" data-id="element-1857">
                      Start met de cursus voor €127. Direct toegang. Begin met
                      stap 1 in slechts 2 minuten.
                    </p>
                    <p className="text-[#5ce0d2] font-bold text-sm mb-4" data-id="element-1858">
                      Per direct toegang.
                    </p>
                    <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-ac" className="block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-lg text-sm" data-id="element-1859">
                      Krijg nu toegang!
                    </a>
                    <p className="text-xs text-gray-500 mt-2" data-id="element-1860">
                      Met 365 dagen 100% geld-terug garantie
                    </p>
                  </div>
                </div>

                {/* Testimonials */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-1861">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-1862">
                    Dit is wat anderen zeggen
                  </div>
                  <div className="p-5 space-y-4" data-id="element-1863">
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-1864">
                      <div className="flex text-[#ffb800] mb-2" data-id="element-1865">
                        <Star className="w-4 h-4 fill-current" data-id="element-1866" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1867" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1868" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1869" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1870" />
                      </div>
                      <p className="text-sm text-gray-700 italic mb-2" data-id="element-1871">
                        "Sinds we de cursus volgen, is de band met Max zoveel
                        sterker geworden. We begrijpen elkaar eindelijk!"
                      </p>
                      <p className="text-xs font-bold text-[#1a2b4a]" data-id="element-1872">
                        - Lisa & Max
                      </p>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-1873">
                      <div className="flex text-[#ffb800] mb-2" data-id="element-1874">
                        <Star className="w-4 h-4 fill-current" data-id="element-1875" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1876" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1877" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1878" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1879" />
                      </div>
                      <p className="text-sm text-gray-700 italic mb-2" data-id="element-1880">
                        "Ik dacht dat mijn hond gewoon koppig was, maar dankzij
                        Amee zie ik nu dat hij me iets probeerde te vertellen.
                        Een wereld van verschil."
                      </p>
                      <p className="text-xs font-bold text-[#1a2b4a]" data-id="element-1881">
                        - Mark & Bella
                      </p>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-1882">
                      <div className="flex text-[#ffb800] mb-2" data-id="element-1883">
                        <Star className="w-4 h-4 fill-current" data-id="element-1884" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1885" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1886" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1887" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1888" />
                      </div>
                      <p className="text-sm text-gray-700 italic mb-2" data-id="element-1889">
                        "De rust in huis is teruggekeerd. Geen frustratie meer,
                        maar echte samenwerking. Bedankt!"
                      </p>
                      <p className="text-xs font-bold text-[#1a2b4a]" data-id="element-1890">
                        - Sarah & Luna
                      </p>
                    </div>
                  </div>
                </div>

                {/* Second pricing CTA */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-1891">
                  <div className="bg-[#5ce0d2] text-[#1a2b4a] text-center py-3 px-4 font-bold text-sm" data-id="element-1892">
                    Start met de Liefdevol Communiceren Cursus
                  </div>
                  <div className="p-5 text-center" data-id="element-1893">
                    <div className="text-[#e53e3e] font-black text-2xl mb-1" data-id="element-1894">
                      Slechts €127 vandaag
                    </div>
                    <div className="text-[#e53e3e] font-bold text-sm mb-3" data-id="element-1895">
                      (Bespaar €70)
                    </div>
                    <p className="text-gray-600 text-sm mb-4" data-id="element-1896">
                      Start met de cursus voor €127. Direct toegang. Begin met
                      stap 1 in slechts 2 minuten.
                    </p>
                    <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-ac" className="block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-lg text-sm" data-id="element-1897">
                      Krijg nu toegang!
                    </a>
                    <p className="text-xs text-gray-500 mt-2" data-id="element-1898">
                      Met 365 dagen 100% geld-terug garantie
                    </p>
                  </div>
                </div>

                {/* Bonussen */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-1899">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-1900">
                    Inclusief Bonussen
                  </div>
                  <div className="p-5 space-y-4" data-id="element-1901">
                    {[{
                    title: '30 dagen community toegang',
                    desc: "Stuur vragen, foto's en videos naar onze experts, neem deel aan meerdere wekelijkse online coachingsessies en kom in contact met andere hondenbaasjes."
                  }, {
                    title: 'Printbare Stappenplannen',
                    desc: 'Handige, printbare overzichten van alle lichaamssignalen en kalmerende signalen om er altijd bij te kunnen pakken.'
                  }, {
                    title: 'Levenslange Toegang',
                    desc: 'Je krijgt levenslange toegang tot al het lesmateriaal, inclusief alle toekomstige updates van de cursus.'
                  }].map((bonus, i) => <div key={`b-${i}`} className="flex items-start gap-3" data-id="element-1902">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-1903" />
                        <div data-id="element-1904">
                          <p className="font-bold text-sm text-[#1a2b4a]" data-id="element-1905">
                            {bonus.title}
                          </p>
                          <p className="text-xs text-gray-500" data-id="element-1906">{bonus.desc}</p>
                        </div>
                      </div>)}
                  </div>
                </div>

                {/* Video Testimonials */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-1907">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-1908">
                    Video Testimonials & Interviews
                  </div>
                  <div className="p-5 space-y-4" data-id="element-1909">
                    {['1084982139', '1084982111', '1084982084'].map(id => <div key={id} className="rounded-lg overflow-hidden shadow-sm" data-id="element-1910">
                        <iframe src={`https://player.vimeo.com/video/${id}?badge=0&autopause=0&player_id=0&app_id=58479`} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" className="w-full aspect-[8/9]" title={`Testimonial ${id}`} data-id="element-1911"></iframe>
                      </div>)}
                  </div>
                </div>

                {/* Final CTA */}
                <div className="bg-[#e6f7f5] rounded-xl p-5 text-center border border-[#5ce0d2]" data-id="element-1912">
                  <p className="font-bold text-[#1a2b4a] text-sm mb-3" data-id="element-1913">
                    3 stappen tot je hond ontspannen alleen kan blijven
                  </p>
                  <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-ac" className="block w-full bg-[#5ce0d2] hover:bg-[#4bc9bd] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-md text-sm" data-id="element-1914">
                    Start nu met de Liefdevol Communiceren Methode
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 19. GUARANTEE */}
      <section className="bg-[#1a2b4a] text-white py-16" data-id="element-1915">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-1916">
          <img src="https://cdn.magicpatterns.com/uploads/tPvpNvykR2KiCNK1pkG2LG/1a50ac51aa1d734ab9af0a73cc65b51b.png" alt="100% Money Back Guarantee" className="w-32 h-32 mx-auto mb-6 object-contain" data-id="element-1917" />
          <h2 className="text-3xl md:text-4xl font-black mb-4 text-[#ffb800]" data-id="element-1918">
            De BESTE Geld-Terug Garantie In De Wereld
          </h2>
          <h3 className="text-2xl font-bold mb-8" data-id="element-1919">
            365 dagen niet-goed, geld-terug garantie:
          </h3>
          <div className="text-lg text-gray-300 leading-relaxed space-y-6 max-w-3xl mx-auto text-left" data-id="element-1920">
            <p data-id="element-1921">
              Kijk, laat me eerlijk tegen je zijn: Ik weet dat voordat ik ergens
              induik… …ik zelf ook wil weten wat ik koop en dat het wordt
              ondersteund door een sterke geld-terug-garantie. En ik wil dat jij
              je comfortabel voelt bij deze aankoop. Ook al is het maar €127 –
              jij hebt voor dat geld gewerkt en het telt.
            </p>
            <p data-id="element-1922">
              Zoals mijn opa altijd zei: "Maak eerst een proefrit, voordat je de
              auto van het terrein afrijdt." Maar hier zit het verschil. Waar de
              meeste mensen je maximaal een garantie van 14 of 30 dagen zouden
              geven… ga ik iets doen wat je waarschijnlijk nog nooit hebt
              gezien.
            </p>
            <p className="font-bold text-white text-xl text-center py-4" data-id="element-1923">
              Ik geef je 365 dagen om de Liefdevol Communiceren Cursus te
              bekijken en toe te passen.
            </p>
            <p data-id="element-1924">
              Ja, je leest het goed. Je krijgt een heel JAAR om deze korte
              training te volgen en toe te passen wat je erin leert. Niet
              slechts een paar weken of een maand. En als je niet volledig
              overdonderd bent door wat je leert… Dan stuur je me gewoon een
              e-mail en vraag je op elk moment binnen die 365 dagen je geld
              terug. We storten je €127 direct terug en je mag toegang tot de
              cursus gratis houden.
            </p>
            <p className="text-center italic mt-8" data-id="element-1925">
              Omdat je nu nog aan het gelezen ben, neem ik aan dat je klaar bent
              om te bestellen, dus met die gedachten...
            </p>
          </div>
        </div>
      </section>

      {/* 20. PRICING CTA */}
      <section className="bg-white py-16 border-b border-gray-200" data-id="element-1926">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-1927">
          <h2 className="text-4xl font-black text-[#1a2b4a] mb-2" data-id="element-1928">
            Vandaag voor €127
          </h2>
          <h3 className="text-2xl font-bold text-[#e53e3e] mb-6" data-id="element-1929">
            (Bespaar €70)
          </h3>
          <img src="https://cdn.magicpatterns.com/uploads/9QvtvBrW74TzrCyCAwHwpa/lc_booklet_mockup.png" alt="Liefdevol Communiceren Stappenplan" className="w-full max-w-md mx-auto mb-8 mix-blend-multiply" data-id="element-1930" />
          <p className="text-lg text-gray-600 mb-8" data-id="element-1931">
            Start met de Liefdevol Communiceren Cursus voor{' '}
            <span className="line-through" data-id="element-1932">€197</span> slechts €127! Direct
            toegang tot online lesmateriaal. Neem de eerste stap in 2 minuten.
          </p>
          <div className="max-w-md mx-auto" data-id="element-1933">
            <CTAButton data-id="element-1934" />
            <p className="text-sm text-gray-500 mt-4 font-bold" data-id="element-1935">
              Met 365 dagen 100% geld terug garantie.
            </p>
          </div>
        </div>
      </section>

      {/* 21. WHAT YOU GET GRID */}
      <section className="bg-[#faf5eb] py-16" data-id="element-1936">
        <div className="max-w-6xl mx-auto px-4" data-id="element-1937">
          <h2 className="text-3xl font-black text-[#1a2b4a] text-center mb-12" data-id="element-1938">
            Dit is wat je krijgt met de training
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1939">
            {[{
            title: 'Liefdevol Communiceren Cursus',
            desc: 'Volledige training in hoe je de Liefdevol Communiceren Methode inzet.',
            image: 'https://cdn.magicpatterns.com/uploads/pPc7pHdzhv1XesyMhYPzEV/lc_book_mockup.png'
          }, {
            title: '30 dagen ondersteuning via Community',
            desc: "Stuur vragen, foto's en videos naar onze experts, neem deel aan meerdere wekelijkse online coachingsessies.",
            image: 'https://cdn.magicpatterns.com/uploads/8mzMhue5NATuWpex23cfs6/2.png'
          }, {
            title: 'Levenslange Toegang',
            desc: 'Je krijgt levenslange toegang tot al het lesmateriaal, inclusief alle toekomstige updates.',
            image: 'https://cdn.magicpatterns.com/uploads/5xTMXACWhxH6FRP25sk6Rf/4.png'
          }, {
            title: 'Printbare Stappenplannen',
            desc: 'Handige, printbare overzichten van alle lichaamssignalen en kalmerende signalen.',
            image: 'https://cdn.magicpatterns.com/uploads/dAT5SmJ1D7wjLPsXTfaXi4/3.png'
          }].map((item, i) => <div key={i} className="bg-white rounded-xl overflow-hidden shadow-md flex flex-col h-full" data-id="element-1940">
                <div className="bg-[#5ce0d2] text-[#1a2b4a] font-bold text-center py-2 text-xs uppercase tracking-wider" data-id="element-1941">
                  INBEGREPEN BIJ JE BESTELLING
                </div>
                <div className="p-6 flex-1 flex flex-col" data-id="element-1942">
                  <div className="w-full h-48 rounded-lg mb-4 flex items-center justify-center overflow-hidden" data-id="element-1943">
                    <img src={item.image} alt={item.title} className="w-full h-full object-contain" data-id="element-1944" />
                  </div>
                  <h4 className="font-bold text-[#1a2b4a] mb-2 leading-tight" data-id="element-1945">
                    {item.title}
                  </h4>
                  <p className="text-sm text-gray-600 mt-auto" data-id="element-1946">{item.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 22. BOTTOM CTA BAR */}
      <div className="bg-[#ffb800] py-8 text-center px-4" data-id="element-1947">
        <div className="max-w-md mx-auto" data-id="element-1948">
          <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-ac" className="block w-full bg-[#1a2b4a] hover:bg-black text-white font-bold py-4 px-4 rounded-lg text-xl transition-colors shadow-lg" data-id="element-1949">
            Krijg nu toegang!
          </a>
          <p className="text-sm text-[#1a2b4a] mt-3 font-bold" data-id="element-1950">
            Met 365 dagen 100% geld-terug garantie
          </p>
        </div>
      </div>

      {/* 24. TURID RUGAAS QUOTE */}
      <section className="bg-white py-16" data-id="element-1951">
        <div className="max-w-4xl mx-auto px-4 flex flex-col md:flex-row items-center gap-8" data-id="element-1952">
          <div className="flex-1 text-center md:text-left" data-id="element-1953">
            <h2 className="text-2xl md:text-3xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-1954">
              Meestal zijn wij, de menselijke soort, degenen die conflicten
              creëren tussen onze honden en onszelf
            </h2>
            <p className="text-lg text-gray-700 mb-2" data-id="element-1955">
              <strong data-id="element-1956">Turid Rugaas</strong>, wereldberoemde Noorse
              hondentrainster, auteur en expert in hondentaal
            </p>
            <p className="text-xs text-gray-400 uppercase tracking-wide" data-id="element-1957">
              DISCLAIMER: Dit is geen aanbeveling van Turid Rugaas
            </p>
          </div>
          <div className="w-48 h-48 flex-shrink-0" data-id="element-1958">
            <img src="https://cdn.magicpatterns.com/uploads/5u3DrMLHNnG7KPDoQAwX5E/e34559c94a8bf7103f4c6cb20d81f245.jpg" alt="Turid Rugaas" className="w-full h-full object-cover rounded-xl shadow-lg grayscale" data-id="element-1959" />
          </div>
        </div>
      </section>

      {/* 25. FAQ */}
      <section className="bg-[#faf5eb] py-16" data-id="element-1960">
        <div className="max-w-5xl mx-auto px-4" data-id="element-1961">
          <h2 className="text-4xl font-black text-[#1a2b4a] text-center mb-16" data-id="element-1962">
            Veelgestelde vragen
          </h2>
          <div className="grid md:grid-cols-2 gap-x-12 gap-y-10" data-id="element-1963">
            {[{
            q: 'Ik wil dit, wat krijg ik exact?',
            a: 'Na je aankoop ontvang je een email met een inlogcode tot ons leerplatform. In dit platform vind je drie uitgebreide modules waarin je alles leert over de Liefdevol Communiceren Methode.'
          }, {
            q: 'Wat is de Liefdevol Communiceren Methode?',
            a: 'Dit is een nieuwe methode waarin je de taalbarrière tussen jou en je hond doorbreekt in plaats van je alleen maar te richten op commanderen. Wij gebruiken deze methode om jaarlijks bij honderden honden gedragsproblemen bij de kern aan te pakken en op te lossen.'
          }, {
            q: 'Kan ik meer hulp krijgen als ik dit wil?',
            a: 'Ja, er is een knop om in contact te komen met iemand van ons team die je meer kan uitleggen over onze 1-op-1 hulp.'
          }, {
            q: 'Wat maakt dit anders dan alle andere informatie online?',
            a: 'Alles wat je kan vinden gaat alleen maar over gehoorzaamheid en correcties. Met deze methode kijk je naar de taal die je hond spreekt, pak je de miscommunicatie bij de kern aan en ga je daarna pas samenwerken. Op deze manier heb je sneller, beter en blijvend resultaat.'
          }, {
            q: 'Voor wie is dit?',
            a: 'Dit is voor hondenbaasjes die de gedragsproblemen van hun hond nu voor eens en altijd willen oplossen en dit op een empatische, liefdevolle manier willen doen.'
          }, {
            q: 'Is er een garantie?',
            a: 'Ja, je krijgt een 365 dagen niet-goed, geld-terug garantie voor het geval je toch niet tevreden bent.'
          }].map((faq, i) => <div key={i} data-id="element-1964">
                <h4 className="font-bold text-xl text-[#1a2b4a] mb-3 flex items-start gap-3" data-id="element-1965">
                  <HelpCircle className="w-6 h-6 text-[#5ce0d2] flex-shrink-0 mt-0.5" data-id="element-1966" />
                  {faq.q}
                </h4>
                <p className="text-[#5ce0d2] pl-9 leading-relaxed" data-id="element-1967">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* WANDELINGEN-BEELD */}
      <section className="bg-[#faf5eb] py-12" data-id="element-1968">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-1969">
          <p className="text-xl md:text-2xl text-gray-700 leading-relaxed font-medium" data-id="element-1970">
            Hoe vaak per dag laat jij je hond uit? Drie keer? Vier keer?
          </p>
          <p className="text-xl md:text-2xl text-gray-700 leading-relaxed font-medium mt-4" data-id="element-1971">
            Dat zijn{' '}
            <span className="font-black text-[#1a2b4a]" data-id="element-1972">
              honderden wandelingen per jaar
            </span>
            . Honderden momenten samen.
          </p>
          <p className="text-xl md:text-2xl text-gray-700 leading-relaxed font-medium mt-4" data-id="element-1973">
            Waarom zouden jullie al die momenten doorbrengen met frustratie en
            spanning, als het ook{' '}
            <span className="text-[#5ce0d2] font-bold" data-id="element-1974">
              ontspannen en verbonden
            </span>{' '}
            kan?
          </p>
          <p className="text-lg text-gray-500 mt-6 italic" data-id="element-1975">
            Eén kleine verandering in hoe jij communiceert, verandert élke
            wandeling. Elke ochtend. Elke avond. Voorgoed.
          </p>
        </div>
      </section>

      {/* 26. FINAL CTA */}
      <div className="bg-[#ffb800] py-12 text-center px-4" data-id="element-1976">
        <div className="max-w-md mx-auto" data-id="element-1977">
          <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-ac" className="block w-full bg-transparent border-4 border-[#1a2b4a] text-[#1a2b4a] hover:bg-[#1a2b4a] hover:text-white font-black py-4 px-4 rounded-lg text-2xl transition-colors" data-id="element-1978">
            Start met deze cursus
          </a>
          <p className="text-sm text-[#1a2b4a] mt-3 font-bold" data-id="element-1979">
            Met 365 dagen 100% geld-terug garantie
          </p>
        </div>
      </div>

      {/* 27. FOOTER */}
      <footer className="bg-[#111827] text-gray-400 py-12 text-xs leading-relaxed text-center px-4" data-id="element-1980">
        <div className="max-w-5xl mx-auto space-y-6" data-id="element-1981">
          <p className="font-bold text-white mb-8" data-id="element-1982">
            This site is not a part of the Facebook website or Facebook Inc.
            Additionally, This site is NOT endorsed by Facebook in any way.
            FACEBOOK is a trademark of FACEBOOK, Inc.
          </p>

          <div className="flex flex-col md:flex-row justify-between items-center gap-6 border-y border-gray-800 py-8 mb-8" data-id="element-1983">
            <p className="font-bold text-white" data-id="element-1984">
              Copywriting van Stressless Dogs Nederland BV
            </p>
            <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-ac" className="bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-8 rounded-lg text-lg transition-colors" data-id="element-1985">
              Start met de cursus.
            </a>
          </div>

          <p className="text-justify" data-id="element-1986">
            We can not and do not make any guarantees about your ability to get
            results or earn any money with our ideas, information, tools, or
            strategies. What we can guarantee is your satisfaction with our
            training. We give you a 30-day 100% satisfaction guarantee on the
            products we sell, so if you are not happy for any reason with the
            quality of our training, just ask for your money back. You should
            know that all products and services by our company are for
            educational and informational purposes only. Nothing on this page,
            any of our websites, or any of our content or curriculum is a
            promise or guarantee of results or future earnings, and we do not
            offer any legal, medical, tax or other professional advice. Any
            financial numbers referenced here, or on any of our sites, are
            illustrative of concepts only and should not be considered average
            earnings, exact earnings, or promises for actual or future
            performance. Use caution and always consult your accountant, lawyer
            or professional advisor before acting on this or any information
            related to a lifestyle change or your business or finances. You
            alone are responsible and accountable for your decisions, actions
            and results in life, and by your registration here you agree not to
            attempt to hold us liable for your decisions, actions or results, at
            any time, under any circumstance.
          </p>
        </div>
      </footer>

      {/* 23. STICKY BOTTOM BAR */}
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#1a2b4a] border-t-4 border-[#5ce0d2] p-3 flex items-center justify-center shadow-[0_-4px_20px_rgba(0,0,0,0.3)]" data-id="element-1987">
        <div className="flex items-center justify-between md:justify-center gap-3 md:gap-8 w-full max-w-5xl" data-id="element-1988">
          <div className="flex items-center gap-3 md:gap-6" data-id="element-1989">
            <img src="https://cdn.magicpatterns.com/uploads/kbsUp8Jcv8Ni5jP2oc579N/Ontwerp_zonder_titel_(70).png" alt="Liefdevol Communiceren Boek" className="hidden md:block w-16 h-auto object-contain" data-id="element-1990" />
            <img src="https://cdn.magicpatterns.com/uploads/fnqxQ7hwmYLpvvLjHhPAxX/Ontwerp_zonder_titel_(69).png" alt="Liefdevol Communiceren Cursus" className="w-16 md:w-24 h-auto object-contain" data-id="element-1991" />
            <div data-id="element-1992">
              <div className="text-white font-bold text-sm md:text-base leading-tight" data-id="element-1993">
                Liefdevol Communiceren Cursus
              </div>
              <div className="text-[#5ce0d2] font-black text-lg md:text-xl" data-id="element-1994">
                <span className="text-red-500 line-through decoration-[3px] mr-2" data-id="element-1995">
                  €197
                </span>
                €127
              </div>
            </div>
          </div>
          <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-ac" className="bg-[#ffb800] text-[#1a2b4a] font-bold py-2 px-6 md:px-8 md:py-3 rounded-lg text-sm md:text-base shadow-md whitespace-nowrap" data-id="element-1996">
            Naar Stap #2
          </a>
        </div>
      </div>
    </div>;
}